import React from 'react'
import { EditorialLayout, Text } from '@babylon/medkit'

import appStyles from '@/App.module.scss'

interface Props {
  pageTitle?: string
  content?: string[]
}

const StepTitle = ({ pageTitle, content }: Props) => (
  <div className={appStyles.StepContent}>
    <EditorialLayout>
      {pageTitle && (
        <Text variant="h2" tag="h1" data-testid="pageTitle">
          {pageTitle}
        </Text>
      )}
      {content &&
        content?.map((copy, index) => (
          <Text
            variant="body"
            key={index}
            data-testid="pageDescription"
            dangerouslySetInnerHTML={{ __html: copy }}
          />
        ))}
    </EditorialLayout>
  </div>
)

export default StepTitle
